import { render } from "./TokenQueue.vue?vue&type=template&id=2ea9cc4b&scoped=true&ts=true"
import script from "./TokenQueue.vue?vue&type=script&lang=ts"
export * from "./TokenQueue.vue?vue&type=script&lang=ts"

import "./TokenQueue.vue?vue&type=style&index=0&id=2ea9cc4b&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea9cc4b"]])

export default __exports__